"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../helpers/index.js");
var _excluded = ["name", "type", "URL", "eventDetails"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var stringField = _index.formatters.stringField;
var getDefaultTemplate = function getDefaultTemplate(_ref) {
  var name = _ref.name,
    type = _ref.type,
    URL = _ref.URL,
    eventDetails = _ref.eventDetails,
    rest = _objectWithoutProperties(_ref, _excluded);
  return [{
    name: stringField(name),
    type: type,
    URL: URL,
    _telus: {
      eventDetails: stringField(eventDetails)
    }
  }, rest];
};
var _default = exports["default"] = getDefaultTemplate;